<template>
  <div v-if="showLinks || forceShowLinks">
    <CustomFormInput
      v-for="item in campaign.feedbackPositiveItems"
      :key="item.key"
      :item="item"
      :feedback-gathering-enabled="campaign.feedbackGatheringEnabled"
      :feedback="feedback" />

    <ReviewLink v-for="link in orderedLinks"
      :key="link.url"
      :link="link"
      :campaign="campaign"
      :contact-id="contactId"
      :rendered-message-id="renderedMessageId"
      :click-link="clickLink" />
  </div>

  <div v-else>
    <div class="thanks">
      <i class="fa fa-check" />

      <CustomFormInput
        v-for="item in campaign.feedbackNegativeItems"
        :key="item.key"
        :item="item"
        :feedback="feedback"
        :feedback-gathering-enabled="campaign.feedbackGatheringEnabled"
        @on-force-show-links="onForceShowLinks"
        @on-change-negative-feedback-body="onChangeNegativeFeedbackBody"
        @save-negative-feedback-body="saveNegativeFeedbackBody" />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ReviewLink from './feedback_page_widget/review_link'
import CustomFormInput from './feedback_page_widget/custom_form_input'

export default {
  props: {
    links: Array,
    showLinks: Boolean,
    campaign: Object,
    rootDomain: String,
    contactId: { type: Number, default: 0 },
    renderedMessageId: { type: String, default: '' },
    feedback: Object
  },
  components: { ReviewLink, CustomFormInput },
  data() {
    return {
      forceShowLinks: false,
      negativeFeedbackBody: ''
    }
  },
  computed: {
    feedbackBody() {
      return this.feedback.body || ''
    }
  },
  methods: {
    onForceShowLinks() {
      this.forceShowLinks = true
    },
    onChangeNegativeFeedbackBody(val) {
      this.negativeFeedbackBody = val
    },
    saveNegativeFeedbackBody() {
      const params = {
        body: this.negativeFeedbackBody,
        campaign_id: this.feedback.campaign_id
      }

      axios.patch(`${this.rootDomain}/ajax/feedbacks/${this.feedback.id}`, params)
    }
  },
  created() {
    const values = Object.values(this.links)
    this.linksCount = values.filter((el) => el).length
    this.clickLink = `${this.rootDomain}/contact_activities/click_link`

    this.orderedLinks = []
    const googleLink = values.find((el) => el.platform === 'Google')
    const fbLink = values.find((el) => el.platform === 'Facebook')
    const customLink = values.find((el) => el.platform === 'Custom Link')
    const otherLinks = values.filter((el) => !(['Google', 'Facebook', 'Custom Link'].includes(el.platform)))

    if (googleLink) this.orderedLinks.push(googleLink)
    if (fbLink) this.orderedLinks.push(fbLink)
    if (customLink) this.orderedLinks.push(customLink)
    if (otherLinks) this.orderedLinks.push(...otherLinks)
  }
}
</script>

<style lang="scss" scoped>
@import '~stylesheets/feedback_page/variables';
@import '~stylesheets/feedback_page/page';
@import '~stylesheets/feedback_page/form';
</style>
